// extracted by mini-css-extract-plugin
module.exports = {"jobCardBC-body":"jobCardBC-body","jobCardBC-body__right":"jobCardBC-body__right","jobCardBC-body__appeal":"jobCardBC-body__appeal"};